import { isBrowser } from '@sortlist-frontend/utils';

import { ConfigOverride, getConfigOverrides } from './overrides';

/**
 * Used in Pages router _app / app Providers
 * Will return the overrides at the `useIsFeatureActive` level
 * regardless if there are experiments running or not
 */
export function useExtractFeatureFlagOverrides(url?: string): ConfigOverride {
  const _url = url ?? (isBrowser() ? window.location.href : undefined);
  return _url == null
    ? {
        configOverrideFromEnvironment: {},
        configOverrideFromLocalStorage: {},
        configOverrideFromParams: {},
      }
    : getConfigOverrides(_url);
}
